import styled from "styled-components";
import Link from "next/link";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.main`
  flex: 1;
  padding: 6rem 2rem 3rem;
  background: white;
`;

export const ContentWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

export const Title = styled.h1`
  font-size: 3rem;
  font-weight: 800;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  font-family: var(--font-poppins), sans-serif;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const Subtitle = styled.p`
  font-size: 1.2rem;
  line-height: 1.8;
  color: #4a5568;
  text-align: center;
  margin-bottom: 3rem;
`;

export const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
`;

export const CardIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
`;

export const CardTitle = styled.h3`
  font-size: 1.3rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.5rem;
`;

export const CardDescription = styled.p`
  font-size: 0.95rem;
  color: #4a5568;
  line-height: 1.5;
`;

export const QuickLinksSection = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 3rem;
`;

export const QuickLinksTitle = styled.h2`
  font-size: 1.75rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  text-align: center;
`;

export const QuickLinksList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const ContactSection = styled.div`
  background: linear-gradient(135deg, #c8553d 0%, #f2853b 100%);
  border-radius: 16px;
  padding: 3rem 2rem;
  text-align: center;
  color: white;
`;

export const ContactTitle = styled.h3`
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 1rem;
`;

export const ContactText = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
`;


export const CategoryCard = styled(Link)`
  background: #f8f9fa;
  border-radius: 12px;
  padding: 2rem;
  text-decoration: none;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 2px solid transparent;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
    border-color: #c8553d;
  }
`;

export const QuickLink = styled(Link)`
  color: #c8553d;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(200, 85, 61, 0.1);
  }
`;

export const ContactButton = styled(Link)`
  display: inline-block;
  background: white;
  color: #c8553d;
  padding: 1rem 3rem;
  border-radius: 50px;
  font-weight: 700;
  font-size: 1.1rem;
  text-decoration: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  }
`;
